$('document').ready(function() {
    $('#search_field_404').submit(function(e){
        if($('#search_404').val() == '' || !$('#search_404').val().replace(/\s/g, '').length){
            e.preventDefault();
        }
    });
});